import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, Observable, of } from 'rxjs';
import {
  sendRequest,
  sendRequestError,
  sendRequestSuccess,
  setLanguage,
} from './drupal-data.actions';
import { TranslocoService } from '@ngneat/transloco';
import {
  JsonApiLoaderResponse,
  JsonApiLoaderService,
} from '../json-api-loader.service';
import { DrupalEntity } from '@nx-icilalune/drupal-types';

@Injectable()
export class DrupalDataEffects {
  languageChange$ = createEffect(() => {
    const langChanges$: Observable<string> = this.translocoService
      .langChanges$ as Observable<string>;
    return langChanges$.pipe(
      map((lang: string) => {
        return setLanguage({ lang });
      })
    );
  });

  triggerRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(sendRequest),
      mergeMap((action) => {
        return this.jsonApiLoaderService
          .loadForReal<JsonApiLoaderResponse<DrupalEntity | DrupalEntity[]>>(
            action.request
          )
          .pipe(
            map((jsonApiLoaderResponse) => {
              const data = jsonApiLoaderResponse.data;
              const result = Array.isArray(data) ? data : [data];
              const ids = result.map((d) => d.id);
              return sendRequestSuccess({
                request: action.request,
                ids,
                contextId: action.contextId,
                canNext:
                  !!jsonApiLoaderResponse.next && !!action.request.paging,
              });
            }),
            catchError((error) => {
              return of(
                sendRequestError({
                  request: action.request,
                  contextId: action.contextId,
                  error,
                })
              );
            })
          );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private translocoService: TranslocoService,
    private jsonApiLoaderService: JsonApiLoaderService
  ) {}
}
